import { Box, Typography, Button } from "@mui/material";
import BlockIcon from "@mui/icons-material/Block";
import { useNavigate } from "react-router-dom";

export function AccessDenied() {
  const navigate = useNavigate();

  return (
    <Box
    sx={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      bgcolor: "#f8fafc",
    }}
  >
    <Box
      sx={{
        textAlign: "center",
        p: 4,
        maxWidth: 560,
        width: "100%",
      }}
    >
      {/* Icon */}
      <Box
        sx={{
          width: 180,
          height: 180,
          borderRadius: "50%",
          bgcolor: "#fdecea",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mx: "auto",
          mb: 4,
        }}
      >
        <BlockIcon sx={{ fontSize: 100, color: "#d32f2f" }} />
      </Box>

      {/* Code */}
      <Typography
        sx={{
          fontSize: { xs: "48px", md: "56px" },
          fontWeight: 700,
          color: "#d32f2f",
          mb: 1,
        }}
      >
        403
      </Typography>

      {/* Title */}
      <Typography
        sx={{
          fontSize: { xs: "22px", md: "26px" },
          fontWeight: 600,
          mb: 2,
          color: "text.primary",
          opacity: 0.75,
        }}
      >
        Access Denied
      </Typography>

      {/* Description */}
      <Typography
        sx={{
          fontSize: { xs: "15px", md: "16px" },
          color: "text.secondary",
          lineHeight: 1.6,
          maxWidth: 480,
          mx: "auto",
          mb: 4,
        }}
      >
        You are not authorized to view this page.
      </Typography>

      {/* Action */}
      <Button
        variant="contained"
        size="large"
        onClick={() => navigate("/product-catalogue")}
        sx={{
          textTransform: "none",
          px: 4,
          py: 1.2,
          borderRadius: 2,
          boxShadow: "0 10px 20px rgba(25, 118, 210, 0.2)",
        }}
      >
        Go back to Product Catalogue
      </Button>
    </Box>
  </Box>
  );
}
